import { z } from "zod";

const MIN_AMOUNT = 500;
const MAX_AMOUNT = 100000;
const MIN_AMOUNT_MESSAGE = `Сумма не может быть меньше ${MIN_AMOUNT} ₽`;
const MAX_AMOUNT_MESSAGE = `Сумма не может быть больше ${MAX_AMOUNT} ₽`;

export const autoTopUpSchema = z
  .object({
    threshold: z
      .string()
      .trim()
      .min(1, "Поле не может быть пустым")
      .refine((val) => !isNaN(Number(val)) && Number(val) > 0, {
        message: "Введите корректную сумму",
      })
      .refine((val) => Number(val) >= MIN_AMOUNT, {
        message: MIN_AMOUNT_MESSAGE,
      })
      .refine((val) => Number(val) <= MAX_AMOUNT, {
        message: MAX_AMOUNT_MESSAGE,
      }),
    amount: z
      .string()
      .trim()
      .min(1, "Поле не может быть пустым")
      .refine((val) => !isNaN(Number(val)) && Number(val) > 0, {
        message: "Введите корректную сумму",
      })
      .refine((val) => Number(val) >= MIN_AMOUNT, {
        message: MIN_AMOUNT_MESSAGE,
      })
      .refine((val) => Number(val) <= MAX_AMOUNT, {
        message: MAX_AMOUNT_MESSAGE,
      }),
    paymentMethodId: z.string().nullable(),
    email: z
      .string()
      .trim()
      .min(1, "Необходимо ввести email")
      .email("Введите корректный email"),
  })
  .superRefine((data, ctx) => {
    if (!data.paymentMethodId) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["paymentMethodId"],
        message: "Для автопополнения необходимо выбрать карту.",
      });
    }
  });

export type AutoTopUpFormValues = z.infer<typeof autoTopUpSchema>;
